import { render, staticRenderFns } from "./BuildWheel.vue?vue&type=template&id=9adb9a24&scoped=true"
import script from "./BuildWheel.vue?vue&type=script&lang=js"
export * from "./BuildWheel.vue?vue&type=script&lang=js"
import style0 from "./BuildWheel.vue?vue&type=style&index=0&id=9adb9a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adb9a24",
  null
  
)

export default component.exports